// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"ohSwaQKEs-QYdcByJHVzb"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

const SENSITIVE_QUERY_KEYS = ['jwt', 'token', 'email'];

const scrubSensitiveQuery = (urlString?: string): string | undefined => {
    if (!urlString) return urlString;
    try {
        const hasOrigin = /^https?:\/\//i.test(urlString);
        const url = hasOrigin
            ? new URL(urlString)
            : new URL(urlString, 'http://placeholder.invalid');
        let mutated = false;
        SENSITIVE_QUERY_KEYS.forEach((key) => {
            if (url.searchParams.has(key)) {
                url.searchParams.set(key, '[scrubbed]');
                mutated = true;
            }
        });
        if (!mutated) return urlString;
        return hasOrigin ? url.toString() : `${url.pathname}${url.search}`;
    } catch {
        return urlString;
    }
};

Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENITRY_DNS,
    enabled: process.env.NEXT_PUBLIC_STAGE === 'production',
    environment: process.env.NEXT_PUBLIC_STAGE,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: false
        })
    ],
    tracePropagationTargets: ['https://hotdesk.com'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 0.33,
    debug: false,
    beforeSend(event, hint) {
        /* tslint:disable:no-string-literal only-arrow-functions */
        const nonErrorExceptions = [
            'Non-Error exception captured',
            'auth/popup-blocked',
            'remoteconfig/fetch-client-parse'
        ];
        let isNonErrorException = false;
        for (let i = 0; i < nonErrorExceptions.length; i++) {
            isNonErrorException = !!(
                (event.exception?.values &&
                    event.exception?.values[0]?.value?.includes(
                        nonErrorExceptions[i]
                    )) ||
                (hint.originalException &&
                    (
                        hint.originalException as { message: string }
                    )?.message?.includes(nonErrorExceptions[i]))
            );
        }
        /* tslint:enable:no-string-literal only-arrow-functions */
        if (isNonErrorException) {
            return null;
        }

        if (event.request) {
            event.request.url = scrubSensitiveQuery(event.request.url);
            if (event.request.query_string && typeof event.request.query_string === 'string') {
                const scrubbed = scrubSensitiveQuery(`?${event.request.query_string}`);
                event.request.query_string = scrubbed?.replace(/^\?/, '') ?? event.request.query_string;
            }
        }
        if (event.breadcrumbs) {
            event.breadcrumbs = event.breadcrumbs.map((b) => {
                if (b.data && typeof b.data === 'object' && 'url' in b.data) {
                    return {
                        ...b,
                        data: {
                            ...b.data,
                            url: scrubSensitiveQuery(b.data.url as string)
                        }
                    };
                }
                return b;
            });
        }
        return event;
    }
});
const { version } = require('./package.json');
Sentry.setTag("version", version);